package com.ives.utils.math;

class AxisAngle {
	public var axis:Vector3D;
	public var angle:Float;

	public function new(axis:Vector3D, angle:Float) {
		this.axis = axis;
		this.angle = angle;
	}
}
